// Customizer const
export const TOGGLE_COLLAPSED_NAV = 'TOGGLE_COLLAPSE_MENU';
export const WINDOW_WIDTH = 'WINDOW-WIDTH';
export const SWITCH_LANGUAGE = 'SWITCH-LANGUAGE';

//Contact Module const
export const FETCH_START = 'fetch_start';
export const FETCH_SUCCESS = 'fetch_success';
export const FETCH_ERROR = 'fetch_error';
export const SHOW_MESSAGE = 'SHOW_MESSAGE';
export const HIDE_MESSAGE = 'HIDE_MESSAGE';
export const ON_SHOW_LOADER = 'ON_SHOW_LOADER';
export const ON_HIDE_LOADER = 'ON_HIDE_LOADER';

//Auth const
export const ACTIVE_USER = 'ACTIVE_USER';
export const ACTIVE_USER_SUCCESS = 'ACTIVE_USER_SUCCESS';
export const SIGNUP_USER = 'SIGNUP_USER';
export const SIGNUP_USER_SUCCESS = 'SIGNUP_USER_SUCCESS';
export const SIGNIN_GOOGLE_USER = 'SIGNIN_GOOGLE_USER';
export const SIGNIN_GOOGLE_USER_SUCCESS = 'SIGNIN_GOOGLE_USER_SUCCESS';
export const SIGNIN_FACEBOOK_USER = 'SIGNIN_FACEBOOK_USER';
export const SIGNIN_FACEBOOK_USER_SUCCESS = 'SIGNIN_FACEBOOK_USER_SUCCESS';
export const SIGNIN_TWITTER_USER = 'SIGNIN_TWITTER_USER';
export const SIGNIN_TWITTER_USER_SUCCESS = 'SIGNIN_TWITTER_USER_SUCCESS';
export const SIGNIN_GITHUB_USER = 'SIGNIN_GITHUB_USER';
export const SIGNIN_GITHUB_USER_SUCCESS = 'signin_github_user_success';
export const SIGNIN_USER = 'SIGNIN_USER';
export const SIGNIN_USER_SUCCESS = 'SIGNIN_USER_SUCCESS';
export const SIGNIN_EXTERNAL_USER = 'SIGNIN_EXTERNAL_USER';
export const SET_TOKEN = 'SET_TOKEN';
export const SIGNIN_EXTERNAL_USER_SUCCESS = 'SIGNIN_EXTERNAL_USER_SUCCESS';
export const SIGNIN_EXTERNAL_USER_CALLBACK = 'SIGNIN_EXTERNAL_USER_CALLBACK';
export const SIGNIN_EXTERNAL_USER_CALLBACK_SUCCESS = 'SIGNIN_EXTERNAL_USER_CALLBACK_SUCCESS';
export const SIGNOUT_USER = 'SIGNOUT_USER';
export const SIGNOUT_USER_SUCCESS = 'SIGNOUT_USER_SUCCESS';
export const INIT_URL = 'INIT_URL';
export const USER_DATA = 'user_data';
export const USER_TOKEN_SET = 'user_token_set';
export const USER_FORGET = 'USER_FORGET';
export const USER_FORGET_SUCCESS = 'USER_FORGET_SUCCESS';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const CHANGE_PASSWORD_SUCCESS = 'CHANGE_PASSWORD_SUCCESS';
export const CHANGE_USER_PASSWORD = 'CHANGE_USER_PASSWORD';
export const CLEAR_TOKEN = 'CLEAR_TOKEN';
///////////////////Contact
export const GET_CONTACT = 'GET_CONTACT';
export const GET_CONTACT_SUCCESS = 'GET_CONTACT_SUCCESS';
//////////////////Missing
export const GET_MISSING = 'GET_MISSING';
export const GET_MISSING_SUCCESS = 'GET_MISSING_SUCCESS';
export const SHOW_Missing_MESSAGE = 'SHOW_Missing_MESSAGE';
export const HIDE_Missing_MESSAGE = 'HIDE_Missing_MESSAGE';
export const ON_SHOW_Missing_LOADER = 'ON_SHOW_Missing_LOADER';
export const ON_HIDE_Missing_LOADER = 'ON_HIDE_Missing_LOADER';
export const ON_ADD_Missing = 'ON_ADD_Missing';
export const ON_ADD_Missing_Success = 'ON_ADD_Missing_Success';
//////////////////EtcMissing
export const GET_ETC_MISSING = 'GET_ETC_MISSING';
export const GET_ETC_MISSING_SUCCESS = 'GET_ETC_MISSING_SUCCESS';
export const SHOW_ETC_Missing_MESSAGE = 'SHOW_ETC_Missing_MESSAGE';
export const HIDE_ETC_Missing_MESSAGE = 'HIDE_ETC_Missing_MESSAGE';
export const ON_SHOW_ETC_Missing_LOADER = 'ON_SHOW_ETC_Missing_LOADER';
export const ON_HIDE_ETC_Missing_LOADER = 'ON_HIDE_ETC_Missing_LOADER';
export const ON_ADD_ETC_Missing = 'ON_ADD_ETC_Missing';
export const ON_ADD_ETC_Missing_Success = 'ON_ADD_ETC_Missing_Success';
//////////////////Found
export const GET_FOUND = 'GET_FOUND';
export const GET_FOUND_SUCCESS = 'GET_FOUND_SUCCESS';
export const SHOW_FOUND_MESSAGE = 'SHOW_FOUND_MESSAGE';
export const HIDE_FOUND_MESSAGE = 'HIDE_FOUND_MESSAGE';
export const ON_SHOW_FOUND_LOADER = 'ON_SHOW_FOUND_LOADER';
export const ON_HIDE_FOUND_LOADER = 'ON_HIDE_FOUND_LOADER';
export const ON_ADD_FOUND = 'ON_ADD_FOUND';
export const ON_ADD_FOUND_SUCCESS = 'ON_ADD_FOUND_SUCCESS';

///////////////Payment
export const ON_ADD_PAYMENT = 'ON_ADD_PAYMENT';
export const ON_ADD_PAYMENT_SUCCESS = 'ON_ADD_PAYMENT_SUCCESS';
//////////////////ADMIN   
export const GET_LOG = 'GET_LOG';
export const GET_LOG_SUCCESS = 'GET_LOG_SUCCESS';
export const GET_USER = 'GET_USER';
export const GET_USER_SUCCESS = 'GET_USER_SUCCESS';
export const GET_ADMIN_MISSING = 'GET_ADMIN_MISSING';
export const GET_ADMIN_MISSING_SUCCESS = 'GET_ADMIN_MISSING_SUCCESS';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const RESET_PASSWORD_SUCCESS = 'RESET_PASSWORD_SUCCESS';
export const CHANGE_ADDRESS = 'CHANGE_ADDRESS';
export const CHANGE_ADDRESS_SUCCESS = 'CHANGE_ADDRESS_SUCCESS';
export const GET_ETCMISSING = 'GET_ETCMISSING';
export const GET_ETCMISSING_SUCCESS = 'GET_ETCMISSING_SUCCESS';
export const GET_ADMIN_FOUND = 'GET_ADMIN_FOUND';
export const GET_ADMIN_FOUND_SUCCESS = 'GET_ADMIN_FOUND_SUCCESS';
export const GET_SETTING = 'GET_SETTING';
export const GET_SETTING_SUCCESS = 'GET_SETTING_SUCCESS';
export const UPDATE_SETTING = 'UPDATE_SETTING';
export const UPDATE_SETTING_SUCCESS = 'UPDATE_SETTING_SUCCESS';
export const CHANGE_ACCOUNT_STATUS = 'CHANGE_ACCOUNT_STATUS';
export const CHANGE_ACCOUNT_STATUS_SUCCESS = 'CHANGE_ACCOUNT_STATUS_SUCCESS';
export const CHANGE_ROLE = 'CHANGE_ROLE';
export const CHANGE_ROLE_SUCCESS = 'CHANGE_ROLE_SUCCESS';
export const CHANGE_MISSING_STATUS = 'CHANGE_MISSING_STATUS';
export const CHANGE_MISSING_STATUS_SUCCESS = 'CHANGE_MISSING_STATUS_SUCCESS';
export const CHANGE_ETC_MISSING_STATUS = 'CHANGE_ETC_MISSING_STATUS';
export const CHANGE_ETC_MISSING_STATUS_SUCCESS = 'CHANGE_ETC_MISSING_STATUS_SUCCESS';
export const SHOW_ADMIN_MESSAGE = 'SHOW_ADMIN_MESSAGE';
export const HIDE_ADMIN_MESSAGE = 'HIDE_ADMIN_MESSAGE';
export const ON_SHOW_ADMIN_LOADER = 'ON_SHOW_ADMIN_LOADER';
export const ON_HIDE_ADMIN_LOADER = 'ON_HIDE_ADMIN_LOADER';
export const ADD_WHITE_LIST = 'ADD_WHITE_LIST';
export const ADD_WHITE_LIST_SUCCESS = 'ADD_WHITE_LIST_SUCCESS';
export const REMOVE_WHITE_LIST = 'REMOVE_WHITE_LIST';
export const REMOVE_WHITE_LIST_SUCCESS = 'REMOVE_WHITE_LIST_SUCCESS';
export const GET_WHITE_LIST = 'GET_WHITE_LIST';
export const GET_WHITE_LIST_SUCCESS = 'GET_WHITE_LIST_SUCCESS';
export const DELETE_EVENT = 'DELETE_EVENT';
export const DELETE_EVENT_SUCEESS = 'DELETE_EVENT_SUCEESS';
export const ADMIN_REPORT = 'ADMIN_REPORT';
export const ADMIN_REPORT_SUCEESS = 'ADMIN_REPORT_SUCEESS';
export const ADMIN_GET_MISSION_BY_ID = 'ADMIN_GET_MISSION_BY_ID';
export const ADMIN_GET_MISSION_BY_ID_SUCCESS = 'ADMIN_GET_MISSION_BY_ID_SUCCESS';
export const ON_UPDATE_Missing_Success = 'ON_UPDATE_Missing_Success';
export const ON_UPDATE_Missing = 'ON_UPDATE_Missing';



